<template>
    <router-view />
</template>

<script>
import { USER } from '@/utils/event/constants.ts';
import { redirect } from '@/assets/util/return-url';
import { emitter } from '@/utils/event/emitter.ts';

export default {
    name: 'User',
    data() {
        return {
            handleGuid: true,
        };
    },
    created() {
        emitter.on(USER.REDIRECT, this.onRedirect);
        emitter.on(USER.GUID, this.onGuid);
    },
    beforeDestroy() {
        emitter.off(USER.REDIRECT, this.onRedirect);
        emitter.off(USER.GUID, this.onGuid);
    },
    methods: {
        onRedirect(value) {
            this.handleGuid = value;
        },
        onGuid() {
            if (!this.handleGuid) return;

            redirect(route => this.$router.push(route));
        },
    },
};
</script>
